/** Hvilken flate du staar paa. Samme form som i feltappen. */
export function Prikker({
  antall, index, navn, onVelg,
}: {
  readonly antall: number;
  readonly index: number;
  readonly navn: readonly string[];
  onVelg(i: number): void;
}): JSX.Element {
  return (
    <div className="prikker">
      {Array.from({ length: antall }, (_, i) => (
        <button
          key={i}
          type="button"
          className={`prikker__prikk${i === index ? " prikker__prikk--aktiv" : ""}`}
          aria-label={`${navn[i] ?? `Side ${i + 1}`}, side ${i + 1} av ${antall}`}
          aria-current={i === index}
          onClick={() => onVelg(i)}
        />
      ))}
    </div>
  );
}
